// Service Upload - Utilise le Cloudflare Worker pour l'upload vidéo
const WORKER_URL = 'https://yuume-upload.contact-iawatch.workers.dev';

/**
 * Crée une URL d'upload direct vers Cloudflare Stream
 */
export const createUploadUrl = async ({ title = 'Video', maxDurationSeconds = 1800 }) => {
  try {
    const response = await fetch(`${WORKER_URL}/api/upload/create-url`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ title, maxDurationSeconds }),
    });

    const data = await response.json();
    
    if (data.success) {
      return {
        success: true,
        uploadURL: data.uploadURL,
        videoId: data.uid,
      };
    } else {
      return {
        success: false,
        error: data.error || 'Erreur création URL upload',
      };
    }
  } catch (error) {
    console.error('Erreur createUploadUrl:', error);
    return {
      success: false,
      error: error.message,
    };
  }
};

/**
 * Vérifie le statut d'une vidéo sur Cloudflare Stream
 */
export const checkVideoStatus = async (videoId) => {
  try {
    const response = await fetch(`${WORKER_URL}/api/upload/status/${videoId}`, {
      method: 'GET',
    });

    const data = await response.json();
    
    if (data.success) {
      return {
        success: true,
        status: data.status,
        playbackUrl: data.playbackUrl,
        thumbnailUrl: data.thumbnailUrl,
        duration: data.duration,
        ready: data.ready,
      };
    } else {
      return {
        success: false,
        error: data.error || 'Vidéo non trouvée',
      };
    }
  } catch (error) {
    console.error('Erreur checkVideoStatus:', error);
    return {
      success: false,
      error: error.message,
    };
  }
};

/**
 * Upload un fichier vidéo vers Cloudflare Stream
 * @param {string} uploadUrl - URL d'upload obtenue via createUploadUrl
 * @param {File} file - Fichier vidéo à uploader
 * @param {function} onProgress - Callback pour le progrès (0-100)
 */
export const uploadVideoToCloudflare = (uploadUrl, file, onProgress) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const xhr = new XMLHttpRequest();
    
    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const progress = Math.round((event.loaded / event.total) * 100);
        if (onProgress) onProgress(progress);
      }
    });
    
    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({ success: true });
      } else {
        reject(new Error(`Upload échoué: ${xhr.status}`));
      }
    });
    
    xhr.addEventListener('error', () => {
      reject(new Error('Erreur réseau pendant l\'upload'));
    });
    
    xhr.open('POST', uploadUrl);
    xhr.send(formData);
  });
};

/**
 * Health check du Worker
 */
export const healthCheck = async () => {
  try {
    const response = await fetch(`${WORKER_URL}/api/health`);
    const data = await response.json();
    return data;
  } catch (error) {
    return { status: 'ERROR', error: error.message };
  }
};

export default {
  createUploadUrl,
  checkVideoStatus,
  uploadVideoToCloudflare,
  healthCheck,
};
